"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../Icons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Select = _ref => {
  let {
    className,
    disabled = false,
    size = 'medium',
    value,
    onChange: _onChange,
    options,
    style
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "relative font-size-15px",
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: size + ' hpd ' + className,
    type: "select",
    value: value,
    disabled: disabled,
    onChange: e => _onChange(e.target.value)
  }, options.map(option => /*#__PURE__*/_react.default.createElement("option", {
    key: option.value,
    value: option.value,
    disabled: option.disabled
  }, option.name))), /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "chevrondown",
    size: "small",
    className: "absolute pointer-events-none",
    style: {
      top: '10px',
      right: '6px'
    }
  }));
};
var _default = exports.default = Select;